// extracted by mini-css-extract-plugin
export default {"header":"styles_header__a-Igl","title":"styles_title__cv7ou","voltar":"styles_voltar__p+-Zs"};